<div class="side-bar-bg" id="side_bar">
    <div class="side-bar">
        <img class="cignal-img" src="assets/images/cignal_logo.png">
    
        <div class="side-bar-item-list">
            <a href="/dashboard"  [ngClass]="{'active': page == 1}" class="side-bar-item">
                <app-svg class="side-svg" 
                    width="20px"
                    height="20px"
                    color="{page == 1 ? 'black' : 'white'}"
                    src="assets/svg/dashboard.svg">
                </app-svg>
                <span>        
                    Dashboard
                </span>
            </a>
            <!-- <a href="order-history" [ngClass]="{'active': page == 3}" class="side-bar-item">
                <app-svg class="side-svg" 
                    width="20px"
                    height="20px"
                    color="{page == 1 ? 'black' : 'white'}"
                    src="assets/svg/purchase_order_history.svg">
                </app-svg>
                <span>        
                    Purchase Order History
                </span>
            </a> -->

            <a href="sell-in" [ngClass]="{'active': page == 10}" class="side-bar-item">
                <app-svg class="side-svg" 
                    width="20px"
                    height="20px"
                    color="{page == 1 ? 'black' : 'white'}"
                    src="assets/svg/sell-in.svg">
                </app-svg>
                <span>        
                    Sell-in
                </span>
            </a>

            <a href="sell-out" [ngClass]="{'active': page == 6}" class="side-bar-item">
                <app-svg class="side-svg" 
                    width="20px"
                    height="20px"
                    color="{page == 1 ? 'black' : 'white'}"
                    src="assets/svg/sell-out.svg">
                </app-svg>
                <span>        
                    Sell-out
                </span>
            </a>

            <!-- <a href="sell-history" [ngClass]="{'active': page == 4}" class="side-bar-item">
                <app-svg class="side-svg" 
                    width="20px"
                    height="20px"
                    color="{page == 1 ? 'black' : 'white'}"
                    src="assets/svg/sell_out_history.svg">
                </app-svg>
                <span>        
                    Sell-out History
                </span>
            </a> -->
            
            
            <a href="e-pins"[ngClass]="{'active': page == 9}" class="side-bar-item">
                <app-svg class="side-svg" 
                    width="20px"
                    height="20px"
                    color="{page == 1 ? 'black' : 'white'}"
                    src="assets/svg/wallet-fill.svg">
                </app-svg>
                <span>        
                    E-pins
                </span>
            </a>

            <mat-expansion-panel 
            [expanded]="page == 7 || page == 8"
            class="expansion-panel">
                <mat-expansion-panel-header class="panel-header">
                  <mat-panel-title class="panel-title">
                    
                    <app-svg class="side-svg" 
                        width="20px"
                        height="20px"
                        color="{page == 1 ? 'black' : 'white'}"
                        src="assets/svg/user-list.svg">
                    </app-svg>
                    <span>        
                        Users
                    </span>

                  </mat-panel-title>
                </mat-expansion-panel-header>
              
                <a href="user-list"[ngClass]="{'active': page == 7}" class="side-bar-item">
                    <app-svg class="side-svg" 
                        width="20px"
                        height="20px"
                        color="{page == 1 ? 'black' : 'white'}"
                        src="assets/svg/list-ul.svg">
                    </app-svg>
                    <span>        
                        List
                    </span>
                </a>

                <a href="user-hierarchy"[ngClass]="{'active': page == 8}" class="side-bar-item">
                    <app-svg class="side-svg" 
                        width="20px"
                        height="20px"
                        color="{page == 1 ? 'black' : 'white'}"
                        src="assets/svg/sort-down-alt.svg">
                    </app-svg>
                    <span>        
                        Hierarchy
                    </span>
                </a>
              
            </mat-expansion-panel>

            <a href="exports"[ngClass]="{'active': page == 5}" class="side-bar-item">
                <app-svg class="side-svg" 
                    width="20px"
                    height="20px"
                    color="{page == 1 ? 'black' : 'white'}"
                    src="assets/svg/export.svg">
                </app-svg>
                <span>        
                    Exports
                </span>
            </a>
        </div>
    
    </div>

    <div class="w-25 h-100" (click)="closeSidebar()">

    </div>
</div>